import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

// Composants graphiques
import { PannelComponent } from './components/pannel.component';
import { WidgetPannelComponent } from './components/widget-pannel.component'

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,
	],
	providers: [
	],
	declarations: [
		PannelComponent,
		WidgetPannelComponent,
	],
	exports: [
		PannelComponent,
		WidgetPannelComponent,
	]
})
export class PannelModule {
	constructor() { }
}